const eur = new Intl.NumberFormat("it-IT", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export function formatPrice(value) {
  if (value === null || value === undefined) return "";
  return eur.format(value);
}

export function gradeShort(grade) {
  const map = { nuovo: "Nuovo", like_new: "Come nuovo", used: "Usato" };
  return map[grade] || grade;
}
